// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolioTitle {
  font-style: italic;
  text-decoration: none;
  margin: 0px;
  animation: portfolioTitleLoad 500ms ease-in;
}

.projectContainer {
  display: flex;
  flex-direction: row;
  margin: 30px;
  justify-content: center;
  min-height: 400px;
}

.projectTextContainer {
  float: left;
  margin-left: 20px;
}

.projectTitle {
  animation: fadeIn linear 1.75s;
  font-weight: bolder;
  text-align: left;
  margin-bottom: -16px;
  margin-top: 0;
}

.projectDescription {
  animation: fadeIn linear 1.75s;
  line-height: 175%;
  font-size: 16px;
  max-width: 400px;
}

.slider {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.arrows {
  font-size: 150%;
  color: #000099;
}

.arrows:hover {
  cursor: pointer;
}

.portfolioHr {
  border-top: 1px solid #000099;
  width: 75%;
}

.sliderImg {
  animation: fadeIn linear 1.75s;
  height: 350px;
  width: 600px;
}

.projectTextContainer > form {
  text-align: center;
}

@keyframes portfolioTitleLoad {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

input[type='submit'] {
  background-color: #000099;
  color: #faf9f6;
  width: 50%;
  padding: 8px;
  margin: 0px;
  font-weight: 200;
  font-size: 20px;
  border: 0;
  border-radius: 24px 24px;
  text-decoration: none;
}

@media only screen and (max-width: 769px) {
  .projectContainer {
    flex-direction: column;
    align-items: flex-start;
  }
  .projectDescription {
    width: 100%;
  }
  .sliderImg {
    width: 100%;
    height: auto;
  }
  .projectDescription {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Portfolio.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".portfolioTitle {\n  font-style: italic;\n  text-decoration: none;\n  margin: 0px;\n  animation: portfolioTitleLoad 500ms ease-in;\n}\n\n.projectContainer {\n  display: flex;\n  flex-direction: row;\n  margin: 30px;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.projectTextContainer {\n  float: left;\n  margin-left: 20px;\n}\n\n.projectTitle {\n  animation: fadeIn linear 1.75s;\n  font-weight: bolder;\n  text-align: left;\n  margin-bottom: -16px;\n  margin-top: 0;\n}\n\n.projectDescription {\n  animation: fadeIn linear 1.75s;\n  line-height: 175%;\n  font-size: 16px;\n  max-width: 400px;\n}\n\n.slider {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.arrows {\n  font-size: 150%;\n  color: #000099;\n}\n\n.arrows:hover {\n  cursor: pointer;\n}\n\n.portfolioHr {\n  border-top: 1px solid #000099;\n  width: 75%;\n}\n\n.sliderImg {\n  animation: fadeIn linear 1.75s;\n  height: 350px;\n  width: 600px;\n}\n\n.projectTextContainer > form {\n  text-align: center;\n}\n\n@keyframes portfolioTitleLoad {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\ninput[type='submit'] {\n  background-color: #000099;\n  color: #faf9f6;\n  width: 50%;\n  padding: 8px;\n  margin: 0px;\n  font-weight: 200;\n  font-size: 20px;\n  border: 0;\n  border-radius: 24px 24px;\n  text-decoration: none;\n}\n\n@media only screen and (max-width: 769px) {\n  .projectContainer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .projectDescription {\n    width: 100%;\n  }\n  .sliderImg {\n    width: 100%;\n    height: auto;\n  }\n  .projectDescription {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
